import React, { useEffect, useState } from 'react';
import { playSound, stopSound } from '../../utils/audio-helper';
import './index.css';

const ResultScreen = props => {

	const { 
			transitionOut, 
			status, 
			points, 
			sounds, 
			avatar, 
			submissionStatus, 
			resetSubmissionResult,
			resetSubmissionStatus,
			submissionResult, //comment for testing
			showPrizeResult //comment for testing
		} = props,
		// submissionResult = {status:407}, // uncomment already test
		// submissionResult = {prizeId:'prize-shirt'}, // uncomment test
		// submissionResult = {prizeId:'prize-mug'}, // uncomment test
		// submissionResult = {prizeId:'prize-giftcard'}, // uncomment test
		// submissionResult = {prizeId:'prize-hat'}, // uncomment test
		// submissionResult = {prizeId:'prize-ep'}, // uncomment test
		// showPrizeResult = true, //test
		[prizeId, setPrizeId] = useState(null),
		[isWinner, setIsWinner] = useState(false), //winner result test
		[resultMessage, setResultMessage] = useState(''),
		resultClassName = (isWinner ? 'won':'lost'),
		handleAnimationEnd = evt => {
			const { animationName } = evt;

			if (animationName === 'scrolling-bg') {
				// transitionOut('game');
			} 
		},
		getPrizeMsg = pid => {
			let prizeMessage = '',
				prizeLink = '';
	
			if (pid !== null) {
				switch (pid) {
					case 'prize-mug':
							prizeMessage = 'You won a Mug';
							prizeLink = 'https://forms.gle/VndoDszVXfVAc9Af7';
						break;
					case 'prize-shirt':
							prizeMessage = 'You won a Shirt';
							prizeLink = 'https://forms.gle/dJhX4VVERPgqbXME6';
						break;
					case 'prize-giftcard':
							prizeMessage = 'You won a $20 Giftcard';
							prizeLink = 'https://forms.gle/91mH1bKikyzo2bY1A';
						break;
					case 'prize-hat':
							prizeMessage = 'You won a Hat';
							prizeLink = 'https://forms.gle/6UtMKiDRq4GiCFLk7';
						break;
					case 'prize-ep':
							prizeMessage = 'You won a Free Episode';
					default:
						break;
				}
			}

			return [prizeMessage, prizeLink];
		},
		renderPrizeContainer = () => {

			return (
				<div className='prize-container'>
					{getPrizeMsg(prizeId)}
				</div>
			);
		},
		renderCTAContainer = () => {
			if (prizeId !== null) {
				return (
					<div className="cta-container">
						<a className="replay-btn no-animation" onClick={()=>{transitionOut('game')}}>Play Again</a>
						<a className="external-btn" target="_blank" href="https://blog.gameshownetwork.com/watch-split-second/">Watch Show</a>
						<a className="external-btn" target="_blank" href="https://www.gameshownetwork.com/games">All Games</a>
					</div>
				);
			}

			return (
				<div className="cta-container">
					<a className="replay-btn" onClick={()=>{transitionOut('game')}}>Continue Game</a>
				</div>
			);
		},
		setSweepsResult = () => {
			if (submissionResult && submissionResult.status===407) {
				resetSubmissionResult();
				resetSubmissionStatus();
				return setResultMessage('Already Entered');
			}

			if (submissionResult && submissionResult.status===0) {
				resetSubmissionResult();
				resetSubmissionStatus();
				return setResultMessage('Error')
			}

			if (showPrizeResult) {
				setPrizeId(submissionResult.prizeId);
				resetSubmissionResult();
				resetSubmissionStatus();
				setResultMessage(getPrizeMsg(submissionResult.prizeId)[0]);
			} else {
				return transitionOut('game');
			}
		},
		renderClaimLink = ()=>{
			if (prizeId !== null) {
				const link  = getPrizeMsg(prizeId)[1];

				if (link !== '') {
					return (
						<a className="external-btn claim-link" target="_blank" href={link}>Claim Prize</a>
					);
				}
			}

			return null;
		};

	useEffect(()=>{
		stopSound(sounds, 'game');

		if (showPrizeResult) {
			// playSound(sounds, 'winning', {volume: 0.2});
		}
		
		if (isWinner) {
		} else {
			// playSound(sounds, 'lose', {volume: 0.2});
		}

		setSweepsResult();
	},[]);

	return (
		<div className={"split-second-sweep-result " + resultClassName} onAnimationEnd={handleAnimationEnd}>
			<header>
				<div className='logo-container'>
					<div className="logo" />
					<div className="tunein"><gsntv-wc-tune-in show-id="split-second"></gsntv-wc-tune-in></div>
				</div>
			</header>
			{/* {renderPrizeContainer()} */}
			<div className="result-message">
				<p className="prize-message">
					{resultMessage}
				</p>
				<p>
					And a chance to win the $1000 Grand Prize
				</p>
				{renderClaimLink()}
			</div>
			{renderCTAContainer()}	
			<div className="tunein"><gsntv-wc-tune-in show-id="split-second"></gsntv-wc-tune-in></div>
		</div>
	)
}

export default ResultScreen;